module.exports = __webpack_public_path__ + "img/gif-1.d8f55249.png";